function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "experiences",
  d: "M0,0v512h512V0H0z M482,482H30V30h452V482z"
})));

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "experiences",
  points: "112.4,353 148.4,353 188.9,292 229.3,353 265,353 206.2,269 266.9,182.6 231.2,182.6 188.9,246  146.5,182.6 110.5,182.6 171.2,269 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "experiences",
  d: "M325.7,355.4c25.2,0,39-16.2,43.7-24.2c0,0-2.1,23.5,21.1,23.5c3.5,0,8.1-0.6,13.7-1.7h0v-27.4 c-2.7-0.2-7.4-6.2-7.4-9.6V177.8h-32.2v71.5c-4.2-7.2-17.2-24.2-42.5-24.2c-29.8,0-56.2,25.9-56.2,65 C266,324.6,288.8,355.4,325.7,355.4z M332.2,252.4c19.6,0,31.1,21,32.4,24.5v30c-1.1,3-10.3,21.1-30.5,21.1 c-21.3,0-34.8-18.9-34.8-37.2C299.3,274.2,310.3,252.4,332.2,252.4z"
});

function SvgXd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXd);
export default __webpack_public_path__ + "static/media/xd.f795e714.svg";
export { ForwardRef as ReactComponent };